<template>
	<div id="cookie-policy" :class="{ 'gnb-hide': isHideGnb }">
		<!-- OneTrust Cookies List start -->
		<div id="ot-sdk-cookie-policy"></div>
	</div>
</template>

<script>
export default {
	name: 'CookiePolicy',
	components: {},
	data() {
		return {
			gnbHideCountries: ['jp'],
		};
	},
	computed: {
		isHideGnb() {
			return this.gnbHideCountries.includes(this.$route.query.country);
		},
	},
	methods: {},
};
</script>
<style lang="less" scoped>
#cookie-policy {
	min-height: 500px;
	padding: 75px 20px 0;

	&.gnb-hide {
		padding-top: 20px;
		background-color: #151517;
		position: relative;
		z-index: 101;
	}

	:deep(#ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy) {
		font-size: 16px;
	}
	:deep(#ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy a) {
		background: transparent;
	}
	:deep(#ot-sdk-cookie-policy-v2.ot-sdk-cookie-policy a:hover) {
		background: transparent;
	}
}
</style>
